import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../../BaseComponents/Image'

type ImageProps = {
    imageUrl: string
    alt?: string
    width: number
}

const BigAudioPlayerImage = ({ imageUrl, alt, width }: ImageProps): ReactElement => (
    <Grid noExpand>
        <Image
            size="M"
            imageUrl={imageUrl}
            alt={alt}
            width={width}
            aspectRatio="1:1"
            radiusType="rounded"
        />
    </Grid>
)

export default BigAudioPlayerImage
